import { useQuery } from '@tanstack/react-query';

import { useQuizStatsFilters } from '@/hooks';
import { sdk } from '@/services';

const QuizResultService = sdk.getService('QuizResultService');

export const useQuizResultsStats = () => {
  const { dateFilter } = useQuizStatsFilters();

  const queryKey = ['quiz-results', 'stats', 'me', dateFilter];
  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: () => QuizResultService.findQuizResultsStats(dateFilter)
  });

  return {
    isLoading,
    quizResultsStats: data
  };
};
